import isEmpty from 'lodash/isEmpty';

function setAlert(type, message) {
	if (isEmpty(message)) { return }

	let alertSystem = document.getElementsByClassName('alert alert-system')[0];
	alertSystem.classList.add(type);
	alertSystem.getElementsByClassName('content')[0].innerHTML = message;
	alertSystem.style.display = 'flex'
	alertSystem.style.opacity = 1

	setTimeout( () => {
		alertSystem.style.opacity = 0
		setTimeout( () => {
			alertSystem.style.display = 'none'
		},
		2000)
	} ,
	5000)
}

function setError(type, message) {
	if (isEmpty(message)) { return }

	let alertSystem = document.getElementsByClassName('error-banner')[0];
	alertSystem.classList.add(type);
	alertSystem.getElementsByClassName('content')[0].innerHTML = message;
	alertSystem.style.display = 'flex'
	alertSystem.style.opacity = 1

	setTimeout( () => {
		alertSystem.style.opacity = 0
		setTimeout( () => {
			alertSystem.style.display = 'none'
		},
		2000)
	} ,
	5000)
}

function setAlertNextPage(type, message) {
	if (isEmpty(message)) { return }
	if (type == 'success') {
		localStorage.setItem('successMessage',
			message)
	} else if (type == 'error') {
		localStorage.setItem('errorMessage',
			message)
	} else {
		raise `${type} is not a valid alert type`
	}
}

export {
	setAlert,
	setAlertNextPage,
	setError,
}
